import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  listFlow: [],
  listComponent: [],
  listAction: [],
};
const slice = createSlice({
  name: "processBuilder",
  initialState,
  reducers: {
    getListFlow() {},
    getListFlowSuccess(state, action) {
      state.listFlow = action.payload;
    },
    getListComponent() {},
    getListComponentSuccess(state, action) {
      state.listComponent = action.payload;
    },
    getListAction() {},
    getListActionSuccess(state, action) {
      state.listAction = action.payload;
    },
    createFlow() {},
    updateFlow() {},
    deleteFlow() {},
    removeComponent() {},
  },
});
export default slice.reducer;

export const {
  getListFlowSuccess,
  getListFlow,
  createFlow,
  updateFlow,
  deleteFlow,
  getListComponent,
  getListComponentSuccess,
  getListAction,
  getListActionSuccess,
  removeComponent,
} = slice.actions;
